// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import MyModal from "components/MyModal";
import * as yup from "yup";
import {
  indetityApiAppToken,
  useInviteOperationUserMutation,
  useRequestChangePasswordMutation,
} from "redux/services/identity";
import {
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import Alert from "components/Alert";
import { useDispatch } from "react-redux";

interface CreateEnterpriseUserProps {
  isOpen: boolean;
  setOpenModalCreate: () => void;
}

const schema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  emailAddress: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
});

const InviteOperationUser = (props: CreateEnterpriseUserProps) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const { isOpen, setOpenModalCreate } = props;
  const [
    createEnterpriseUserMutation,
    {
      isSuccess: createUserSuccess,
      isError: isCreateUserError,
      error: createUserError,
      isLoading: isLoadingInviteUser,
      data: createDataResonse,
    },
  ] = useInviteOperationUserMutation();

  const [
    requestChangePasswordMutation,
    {
      isLoading: isLoadingRequestChangePassword,
      isSuccess: requestPasswordChangeSuccess,
    },
  ] = useRequestChangePasswordMutation();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    return () => {
      dispatch(indetityApiAppToken.util.resetApiState());
    };
  }, []);

  useEffect(() => {
    if (createUserSuccess) {
      requestChangePasswordMuation();
    }
  }, [createUserSuccess]);

  useEffect(() => {
    if (requestPasswordChangeSuccess) {
      toast({
        title: "Approver added successfully",
        status: "success",
        duration: 6000,
        isClosable: true,
        position: "top-right",
      });
      setOpenModalCreate(false);
    }
  }, [requestPasswordChangeSuccess]);

  const requestChangePasswordMuation = async () => {
    if (createDataResonse) {
      await requestChangePasswordMutation({
        userId: createDataResonse.data.uuid,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = async () => {
    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({});
      return true;
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      setErrors(validationErrors);
      return false;
    }
  };

  const handleSubmit = async () => {
    const isValid = await validateForm();

    if (isValid) {
      createEnterpriseUserMutation({
        ...formData,
      });
    }
  };

  return (
    <MyModal
      isOpen={isOpen}
      onClose={() => setOpenModalCreate()}
      title="Add Approver"
      submitBtnText="Add"
      onSubmit={() => handleSubmit()}
      loadingSubmit={isLoadingInviteUser || isLoadingRequestChangePassword}
      scrollBehavior="inside"
      disabledCloseOutSide
    >
      {isCreateUserError && createUserError && (
        <Alert
          status="error"
          mb="10px"
          title={
            (createUserError as any)?.data?.errors
              ?.map((err: any) => err.message)
              ?.join(", ") || "Something went wrong!"
          }
        />
      )}
      <FormControl mb="12px" isInvalid={!!errors.emailAddress}>
        <FormLabel>Email Address</FormLabel>
        <Input
          name="emailAddress"
          data-testid="email-invite-operator"
          value={formData.emailAddress}
          onChange={handleChange}
        />
        {errors.emailAddress && (
          <FormErrorMessage fontSize={12}>
            {errors.emailAddress}
          </FormErrorMessage>
        )}
      </FormControl>
      <FormControl mb="12px" isInvalid={!!errors.firstName}>
        <FormLabel>First Name</FormLabel>
        <Input
          name="firstName"
          data-testid="firstname-invite-operator"
          value={formData.firstName}
          onChange={handleChange}
        />
        {errors.firstName && (
          <FormErrorMessage fontSize={12}>{errors.firstName}</FormErrorMessage>
        )}
      </FormControl>
      <FormControl mb="12px" isInvalid={!!errors.lastName}>
        <FormLabel>Last Name</FormLabel>
        <Input
          name="lastName"
          data-testid="lastname-invite-operator"
          value={formData.lastName}
          onChange={handleChange}
        />
        {errors.lastName && (
          <FormErrorMessage fontSize={12}>{errors.lastName}</FormErrorMessage>
        )}
      </FormControl>
    </MyModal>
  );
};

export default InviteOperationUser;
